"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetStyles = exports.breakbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _cxs = _interopRequireDefault(require("./lib/cxs"));

var _config = _interopRequireDefault(require("./config"));

var _contextTypes = _interopRequireDefault(require("./context-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _slicedToArray(arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return _sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_cxs.default.prefix('_bbx_');

var resolveValue = function resolveValue(spaces, value) {
  if (typeof value !== 'number') return value;
  return value <= spaces.length ? spaces[value - 1] : value + 'px';
};

var getStyles = function getStyles(props, config) {
  var spaces = config.spaces; // Add '0' value for default value (without a media query)

  var breakpoints = [0].concat(_toConsumableArray(config.breakpoints));
  var stylesPerBreakpoint = breakpoints.map(function (b) {
    return [];
  });
  Object.entries(props).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        prop = _ref2[0],
        values = _ref2[1];

    if (Array.isArray(values)) {
      for (var i = 0; i < values.length; i++) {
        var value = values[i];
        if (value === null || value === undefined) continue;
        var resolvedValue = resolveValue(spaces, value);
        stylesPerBreakpoint[i].push([prop, resolvedValue]);
      }
    } else if (values !== null && values !== undefined) {
      stylesPerBreakpoint[0].push([prop, resolveValue(spaces, values)]);
    }
  });
  var styles = stylesPerBreakpoint.reduce(function (result, declarations, index) {
    // const media = stylesPerBreakpoint.length-1 !== index
    //   ? `@media (min-width: ${breakpoints[(stylesPerBreakpoint.length-1) - index]})`
    //   : null
    var media = index !== 0 ? "@media (min-width: ".concat(breakpoints[index], ")") : null;
    var declarationsObj = declarations.reduce(function (res, declaration) {
      var _declaration = _slicedToArray(declaration, 2),
          property = _declaration[0],
          value = _declaration[1];

      res[property] = value;
      return res;
    }, {});
    if (media === null) result = _extends({}, result, declarationsObj);else result[media] = declarationsObj;
    return result;
  }, {});
  Object.keys(styles).forEach(function (key) {
    return Object.keys(styles[key]).length === 0 && delete styles[key];
  });
  return styles;
};

var breakbox = function breakbox(_ref3) {
  var _ref3$containerStyles = _ref3.containerStyles,
      containerStyles = _ref3$containerStyles === void 0 ? {} : _ref3$containerStyles,
      _ref3$displayName = _ref3.displayName,
      displayName = _ref3$displayName === void 0 ? 'Breakbox' : _ref3$displayName;

  var BreakboxComponent = function BreakboxComponent(_ref4, context) {
    var className = _ref4.className,
        style = _ref4.style,
        children = _ref4.children,
        _ref4$tag = _ref4.tag,
        tag = _ref4$tag === void 0 ? 'div' : _ref4$tag,
        otherProps = _objectWithoutProperties(_ref4, ["className", "style", "children", "tag"]);

    var config = Object.assign({}, _config.default, context.breakbox);
    var styles = getStyles(Object.assign(otherProps, containerStyles), config);
    var stylesClassName = (0, _cxs.default)(styles); // used for testing

    var debug = null;

    if (process.env.NODE_ENV === 'test') {
      debug = _react.default.createElement("style", {
        key: "css",
        dangerouslySetInnerHTML: {
          __html: _cxs.default.css()
        }
      });
    }

    var props = {
      className: [className, stylesClassName].join(' ').trim()
    };

    if (style) {
      props.style = style;
    }

    return _react.default.createElement(tag, props, [children, debug]);
  };

  BreakboxComponent.contextTypes = _contextTypes.default;
  BreakboxComponent.displayName = displayName;
  return BreakboxComponent;
};

exports.breakbox = breakbox;

var resetStyles = function resetStyles() {
  return _cxs.default.reset();
};

exports.resetStyles = resetStyles;